<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="board" :is-print="isPrint" />

    <!-- 장비 정보 -->
    <div class="mt-28px">
      <h5 class="my-4"><i class="dot"></i> 장비 정보</h5>
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div>작업내용</div>
          <ml-input :readonly="board.readonly" :isPrint="isPrint" v-model="form.작업내용" :max="300" :visible-counter="true" />
        </div>
        <div>
          <div>공장명</div>
          <ml-input :readonly="board.readonly" :isPrint="isPrint" v-model="form.공장명" :max="100" :visible-counter="true" />
        </div>
        <div>
          <div class="flex gap-1">
            만료일
            <PrintCheckbox v-if="isPrint" :value="form.check만료일" color />
            <vs-checkbox v-else :readonly="board.readonly" v-model="form.check만료일" @change="onChangeCheckDate"></vs-checkbox>
          </div>
          <ml-input v-if="!form.check만료일" readonly v-model="form.만료일" :isPrint="isPrint" />
          <DateSelector v-else :readonly="board.readonly" :isPrint="isPrint" v-model="form.만료일" :max="100" :visible-counter="true" />
        </div>
        <div>
          <div>업체명</div>
          <ml-input :readonly="board.readonly" :isPrint="isPrint" v-model="form.업체명" :max="100" :visible-counter="true" />
        </div>
        <div>
          <div>관리책임자 성명</div>
          <ml-input :readonly="board.readonly" :isPrint="isPrint" v-model="form.관리책임자성명" :max="100" :visible-counter="true" />
        </div>
        <div>
          <div>관리책임자 연락처</div>
          <ml-input :readonly="board.readonly" :isPrint="isPrint" v-model="form.관리책임자연락처" :max="100" :visible-counter="true" />
        </div>
      </div>

      <div class="writeGridContainer">
        <div>
          <div>운전자 성명</div>
          <ml-input :readonly="board.readonly" :isPrint="isPrint" v-model="form.운전자성명" :max="100" :visible-counter="true" />
        </div>
        <div>
          <div>운전자 연락처</div>
          <ml-input :readonly="board.readonly" :isPrint="isPrint" v-model="form.운전자연락처" :max="100" :visible-counter="true" />
        </div>
      </div>

      <div class="writeGridContainer">
        <div>
          <div>작업위치</div>
          <ml-input :readonly="board.readonly" :isPrint="isPrint" v-model="form.작업위치" :max="100" :visible-counter="true" />
        </div>
        <div>
          <div>출입인원</div>
          <div class="after-text">
            <number-input :readonly="board.readonly" :isPrint="isPrint" v-model="form.출입인원" :max="999" :visible-counter="true" />
            <span>명</span>
          </div>
        </div>
      </div>

      <div class="writeGridContainer">
        <div>
          <div>작업기간</div>
          <DateSelectorRang :readonly="board.readonly" :isPrint="isPrint" v-model="form.작업기간" />
        </div>
        <div>
          <div>입문예정시각</div>
          <time-selector :readonly="board.readonly" :isPrint="isPrint" v-model="form.입문예정시각" />
        </div>
        <div>
          <div>출문예정시각</div>
          <time-selector :readonly="board.readonly" :isPrint="isPrint" v-model="form.출문예정시각" />
        </div>
        <div>
          <div>사용 중장비명</div>
          <ml-input :readonly="board.readonly" :isPrint="isPrint" v-model="form.사용중장비명" :max="100" :visible-counter="true" />
        </div>
        <div>
          <div>차량번호</div>
          <ml-input :readonly="board.readonly" :isPrint="isPrint" v-model="form.차량번호" :max="100" :visible-counter="true" />
        </div>
        <div>
          <div>산재보험 번호</div>
          <ml-input :readonly="board.readonly" :isPrint="isPrint" v-model="form.산재보험번호" :max="100" :visible-counter="true" />
        </div>
        <div>
          <div>중량물 취급계획서</div>
          <p v-if="isPrint" class="print-input">{{ form.중량물취급계획서 ? form.중량물취급계획서.fileName : "" }}</p>
          <FileUploader v-else :readonly="board.readonly" v-model="form.중량물취급계획서" />
        </div>
        <div class="writeGridLineItem">
          <div>주요작업</div>
          <ml-textarea :readonly="board.readonly" :isPrint="isPrint" v-model="form.주요작업" :max="2000" :visible-counter="true" />
        </div>
        <div class="writeGridLineItem">
          <div>안전작업 조치사항</div>
          <ml-textarea :readonly="board.readonly" :isPrint="isPrint" v-model="form.안전작업조치사항" :max="2000" :visible-counter="true" />
        </div>
      </div>
    </div>
    <div class="text-box">
      1. 본 사항은 계약전 불가피하게 시행되어야 하는 작업사항이나 돌발작업, A/S작업 등 규정된 “안전작업허가서”가 승인되지 못한 작업의 출입자 관리를 위해 임시로 등록하는 사항이며, 위험이 예상되거나 별도 승인이 필요한 작업에 대하여는 당
      사항을 취소 또는 불허 할 수 있음.<br />
      2. 등록되는 업체는 “산재 보험” 가입된 업체에 한하여 적용하며, 만20세미만, 65세초과 출입은 제한됨.<br />
      3. 본 “장비등록부”에 기재되는 모든 사항은 작성자의 소속팀장 승인[보고] 후 등록되어야 함<br />
    </div>

    <!-- 파일첨부 -->
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-8" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import FileUploader from "@/components/FileUploader.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import DateSelectorRang from "@/components/selector/DateSelectorRang";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import NumberInput from "@/components/NumberInput.vue";
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";

export default {
  components: {
    DateSelector,
    FileUploader,
    FileUploadModule,
    FieldSelectModule,
    DateSelectorRang,
    TimeSelector,
    PrintCheckbox,
    NumberInput,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    header: Object,
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],

        작업내용: "",

        공장명: "",
        check만료일: false,
        만료일: "영구",

        업체명: "",
        관리책임자성명: "",
        관리책임자연락처: "",

        운전자성명: "",
        운전자연락처: "",

        작업위치: "",
        출입인원: 0,

        작업기간: "",
        입문예정시각: "",
        출문예정시각: "",

        사용중장비명: "",
        차량번호: "",
        산재보험번호: "",

        중량물취급계획서: "",
        주요작업: "",
        안전작업조치사항: "",
      },
    };
  },
  computed: {},
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {
    onChangeCheckDate(value) {
      this.$nextTick(() => {
        if (value.target.value === "false") {
          this.form.만료일 = "영구";
        } else {
          this.form.만료일 = "";
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.text-box {
  font-family: Noto Sans KR;
  font-size: 14px;
  font-weight: 500;
  line-height: 25.2px;
  text-align: left;

  padding: 10px;
  border: 1px solid #cdcdcd;
  margin: 28px 0;
}
</style>
